import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Order } from '../../models/Order.model';
import { CartItem } from '../../models/cart-item.model';
import { CartService } from '../../services/cart.service';
import { OrderService } from '../../services/order.service';
import { ToastService } from '../../toast.service';
import { environment } from '../../../environments/environment';
//import { loadStripe, Stripe as StripeType } from '@stripe/stripe-js';
import { PaymentService } from '../../services/payment.service';
import { PaymentRequest } from '../../models/paymentrequest.model';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.css'
})
export class CheckoutComponent implements OnInit {
  checkoutForm!: FormGroup;
  cartItems: CartItem[] = [];
  total: number = 0;
  shippingCharge: number = 60;
  environment = environment;
  loading = false;
  error: string | null = null;
  http: any;
  orderId: any;
  amount: any;
  gateway: any;

  constructor(
    private fb: FormBuilder,
    private cartService: CartService,
    private orderService: OrderService,
    private router: Router,
    private toast: ToastService,
    private paymentService: PaymentService
  ) { }

  ngOnInit(): void {
    //this.cartItems = this.cartService.getCartItems();
    this.cartService.getCartItems().subscribe({
      next: (cart) => {
        this.cartItems = cart.items;
        this.total = this.cartItems.reduce(
          (sum, item) => sum + (item.product.price * item.quantity),
          0
        );
      },
      error: (err) => {
        console.error('Error loading cart items:', err);
      }
    });
    

    this.checkoutForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      address: ['', Validators.required],
      phone: ['', Validators.required],
      city: ['', Validators.required],
      altPhone: ['', Validators.nullValidator],
      notes: ['', Validators.nullValidator],
      paymentMethod: ['cod'] // default selected option
    });
  }

  getButtonText(): string {
    if (this.checkoutForm.value.paymentMethod === 'cod') {
      return 'Confirm Order';
    } else {
      return 'Process to Payment';
    }
  }

  onSubmit() {

    if (this.checkoutForm.value.paymentMethod === 'bKash') {
      console.log('Processing bKash payment...');
      // bKash API logic here

    } else if (this.checkoutForm.value.paymentMethod === 'Stripe' || this.checkoutForm.value.paymentMethod === 'PayPal'
      || this.checkoutForm.value.paymentMethod === 'SSLCommerz') {
      console.log('Processing Visa/Mastercard payment...');
      // Visa/Mastercard API logic here
      this.gateway = this.checkoutForm.value.paymentMethod;
      this.processOrder(true);

    } else if (this.checkoutForm.value.paymentMethod === 'cod') {
      console.log('Order confirmed with Cash on Delivery.');
      // COD logic here
      this.processOrder(false);
    } else {
      alert('Please select a payment method.');
    }
  }

  //get isVisaSelected(): boolean {
  //  return this.checkoutForm.value.paymentMethod === 'visaMastercard';
  //}

  //pay(pGateway: 'Stripe' | 'PayPal') {
  //  if (!this.isVisaSelected) return;
  //  this.gateway = pGateway;
  //  console.log(`Paying with ${pGateway}`);
  //  // Call backend checkout API here
  //  // /api/payments/checkout?gateway=Stripe|PayPal
  //}

  processOrder(payOnline: boolean) {
    if (this.checkoutForm.valid) {
      const customer = this.checkoutForm.value;
      const items = this.cartItems.map(item => ({
        id: 0, // Assuming id is generated by the backend
        orderId: 0, // Assuming orderId is generated by the backend
        productId: item.product.id,
        price: item.product.price,
        quantity: item.quantity,
        Size: item.size,
        vendorId: item.product.vendorId
      }));

      // Create the order object
      const order: Order = {
        name: customer.name,
        email: customer.email,
        phone: customer.phone,
        shippingAddress: customer.address,
        shippingCity: customer.city,
        altPhone: customer.altPhone,
        notes: customer.notes,
        totalAmount: this.total + this.shippingCharge,
        orderDate:'',
        items: items
      };

      // Place the order using the OrderService
      this.orderService.placeOrder(order).subscribe({
        next: (response) => {

          if (!payOnline) {
            this.toast.show('Order placed successfully!', 'success');
            this.cartService.clearCart();
            this.router.navigate(['/order-confirmation', response.id]);
            return;
          }

          if (response.id !== undefined && response.id !== null) {
            this.initiatePayment(response.id.toString());
          } else {
            console.error("Order ID missing in response", response);
          }
        },
        error: (err) => {
          console.error('Error placing order:', err);
        }
      });
    }
    else {
      this.toast.show('Please fillup all the required fields!', 'warning');
    }
  }

  async initiatePayment(orderId: string) {
    this.loading = true;
    this.error = null;

    const paymentRequest: PaymentRequest = {
      orderId: orderId,
      amount: this.total + this.shippingCharge,
      gateway: this.gateway
    };

    this.paymentService.checkout(paymentRequest).subscribe({
      next: (res: any) => {
        console.log('Payment response:', res);

        // Stripe Clover change: redirect directly
        if (res.redirectUrl) {
          window.location.href = res.redirectUrl;
          return;
        }

        //// In case your backend still returns sessionId
        //if (res.sessionId) {
        //  // Stripe no longer supports redirectToCheckout
        //  // Use backend-generated URL
        //  window.location.href = `https://checkout.stripe.com/c/pay/${res.sessionId}`;
        //  return;
        //}

        //// Fallback
        //this.toast.show('Order placed successfully!', 'success');
        //this.cartService.clearCart();
        //this.router.navigate(['/order-confirmation']);
      },

      error: (err) => {
        this.error = err?.error?.message || 'Payment failed.';
        this.loading = false;
      },

      complete: () => {
        this.loading = false;
      }
    });
  }


}


